import { SET_USER_ACTIVITY_CURRENT_PAGE } from '../actions/actionTypes';

const initialState = {
  currentPage: 0,
};

const userActivityReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER_ACTIVITY_CURRENT_PAGE:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default userActivityReducer;
